export enum UserRole {
    ADMIN = 'ADMIN',
    FINAL_USER = 'FINAL_USER',
    STAFF_USER = 'STAFF',
    PROFILE_MANAGEMENT = 'PROFILE_MANAGEMENT',
    PARTNER = 'PARTNER',
    TEAM = 'TEAM',
}

export enum Permission {
    EDIT_PROFILE_IMAGE = 'EDIT_PROFILE_IMAGE',
    EDIT_BIOGRAPHY = 'EDIT_BIOGRAPHY',
    MANAGE_WAITLIST_ADMIN = 'MANAGE_WAITLIST_ADMIN',
    MY_EXPERIENCE = 'MY_EXPERIENCE',
    HOST_EXPERIENCE = 'HOST_EXPERIENCE',
    EXPERIENCE_ADMIN = 'EXPERIENCE_ADMIN',
    MANAGE_MEMBER = 'MANAGE_MEMBER',
    ADMIN_TEAM = 'ADMIN_TEAM',
    TEAM = 'TEAM',
    REFER_MEMBER = 'REFER_MEMBER',
    MANAGE_ADMIN = 'MANAGE_ADMIN',
    MANAGE_PARTNER = 'MANAGE_PARTNER',
    MY_EXPERIENCES = 'MY_EXPERIENCES',
    PARTNER_MY_EXPERIENCE = 'PARTNER_MY_EXPERIENCE',
    MY_MEMBERSHIP = 'MY_MEMBERSHIP',
    PAYMENTS = 'PAYMENTS',
    FINANCIAL_OVERVIEW = 'FINANCIAL_OVERVIEW',
    DASHBOARD_ADMIN = 'DASHBOARD_ADMIN',
    MANAGE_PAYOUTS = 'MANAGE_PAYOUTS',
    MANAGE_COMMISSIONS = 'MANAGE_COMMISSIONS',
    MANAGE_AUDIT_LOG = 'MANAGE_AUDIT_LOG',
}

export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
    [UserRole.ADMIN]: [
        Permission.MANAGE_WAITLIST_ADMIN,
        Permission.MANAGE_MEMBER,
        Permission.MANAGE_ADMIN,
        Permission.MANAGE_PARTNER,
        Permission.EXPERIENCE_ADMIN,
        Permission.MANAGE_PAYOUTS,
        Permission.MANAGE_COMMISSIONS,
        Permission.MANAGE_AUDIT_LOG,
    ],
    [UserRole.STAFF_USER]: [
        Permission.MANAGE_WAITLIST_ADMIN,
        Permission.MANAGE_MEMBER,
        Permission.MANAGE_PARTNER,
        Permission.EXPERIENCE_ADMIN,
        // Note: the sidebar shows the Payouts / Commissions / Audit Log entries to every Staff user,
        // but the backend enforces per-user access via the `financial` and `audit` SystemModule
        // permission matrices (PR-I-22, PR-I-33). Staff without a module get 403 on click.
        Permission.MANAGE_PAYOUTS,
        Permission.MANAGE_COMMISSIONS,
        Permission.MANAGE_AUDIT_LOG,
    ],
    [UserRole.PROFILE_MANAGEMENT]: [
        Permission.EDIT_PROFILE_IMAGE,
        Permission.EDIT_BIOGRAPHY,
    ],
    [UserRole.PARTNER]: [
        Permission.ADMIN_TEAM,
        Permission.EDIT_PROFILE_IMAGE,
        Permission.MY_EXPERIENCES,
        Permission.MY_MEMBERSHIP,
        Permission.PAYMENTS,
        Permission.FINANCIAL_OVERVIEW,
    ],
    [UserRole.FINAL_USER]: [
        Permission.EDIT_PROFILE_IMAGE,
        Permission.EDIT_BIOGRAPHY,
        Permission.REFER_MEMBER,
        Permission.MY_EXPERIENCES,
        Permission.TEAM,
        Permission.MY_MEMBERSHIP,
        Permission.PAYMENTS,
        Permission.FINANCIAL_OVERVIEW,
    ],
}
